import type { ReactNode } from 'react';

interface InfoItemProps {
  badge?: ReactNode;
  children: ReactNode;
  icon: ReactNode;
  label: string;
}

/**
 * InfoItem - Column of the subscription block card: an icon and its label on one row, with
 * the content stacked underneath and aligned to the icon. The optional `badge` renders
 * inline next to the label.
 */
export const InfoItem = ({ badge, children, icon, label }: InfoItemProps) => {
  return (
    <div className="flex min-w-0 flex-col gap-1 font-sans">
      <div className="flex flex-wrap items-center gap-2">
        <span aria-hidden className="h-4 w-4 shrink-0 text-muted-foreground">
          {icon}
        </span>
        <p className="text-xs leading-4 text-muted-foreground">{label}</p>
        {badge}
      </div>

      {children}
    </div>
  );
};
